import type { IconProps } from '../types/IconProps.ts';
export const Coin: IconProps = {
    name: 'Coin',
    children: [
        `<circle cx="12" cy="12" r="8" />`,
        `<path d="M11 9h.8q.18.02.2.2V15" />`,
    ]
};